<template>
  <transition
  tag="div"
  appear
  name="from-right-to-left"
  mode="out-in"
  class="FilesDashboard">
    <FilesDashboardMain
    v-if="isRouteName('files')"
    class="FilesDashboard__content"/>
    <FilesDashboardFolder
    v-if="isRouteName('folder')"
    class="FilesDashboard__content"/>
  </transition>
</template>

<script>
import FilesDashboardFolder from '@/components/files/dashboard/folder/FilesDashboardFolder'
import FilesDashboardMain from '@/components/files/dashboard/main/FilesDashboardMain'

export default {
  name: 'FilesDashboard',

  components: {
    FilesDashboardFolder,
    FilesDashboardMain
  },

  methods: {
    isRouteName (name) {
      return this.$route.name === name
    }
  }
}
</script>

<style lang="scss">
@import 'FilesDashboard';
</style>
